import { createElement } from "react";
import { SHOPIFY_STORE_PERMANENT_DOMAIN } from "@/lib/shopify";

/** Strip Shopify GraphQL gid prefix to get the numeric variant ID. */
function numericVariantId(gid: string): string {
  const m = gid.match(/(\d+)$/);
  return m ? m[1] : gid;
}

export function ShopPayBlock({
  variantId,
  quantity = 1,
  price,
  currency,
  hideButton = false,
}: {
  variantId: string;
  quantity?: number;
  price?: string;
  currency?: string;
  hideButton?: boolean;
}) {
  const numeric = numericVariantId(variantId);
  const storeUrl = `https://${SHOPIFY_STORE_PERMANENT_DOMAIN}`;

  const button = hideButton
    ? null
    : createElement("shop-pay-button", {
        "store-url": storeUrl,
        variants: `${numeric}:${quantity}`,
        channel: "custom_storefront",
      });

  const installments = null;

  if (!button && !installments) return null;

  return (
    <div className="mt-4 space-y-3">
      {button}
      {installments}
    </div>
  );
}

/** Brand-styled "Shop Pay" wordmark for use inside custom buttons. */
export function ShopPayWordmark({ className }: { className?: string }) {
  return (
    <span
      className={
        "inline-flex items-center gap-1 rounded-sm bg-[#5a31f4] px-2 py-0.5 text-[10px] font-bold uppercase tracking-normal text-white " +
        (className ?? "")
      }
      aria-label="Shop Pay"
    >
      <span className="lowercase tracking-tight">shop</span>
      <span className="rounded-[2px] bg-white px-1 text-[8px] leading-none text-[#5a31f4]">
        Pay
      </span>
    </span>
  );
}
